import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import VehicleDetailsV2 from 'src/features/vehicle-details/VehicleDetailsV2';
import VehicleEditPage from 'src/features/vehicle-details/VehicleEditPage';

const VehicleDetailsDialog = ({
  open, onClose, vehicleId, vehicleNumber
}) => {
  const [editing, setEditing] = useState(false);
  const [editSection, setEditSection] = useState('edit-identity');

  const closeDialog = () => {
    setEditing(false);
    setEditSection('edit-identity');
    onClose();
  };

  const openEditor = (section = 'edit-identity') => {
    setEditSection(section);
    setEditing(true);
  };

  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      fullWidth
      maxWidth={false}
      aria-labelledby={`vehicle-details-dialog-title-${vehicleId}`}
      PaperProps={{
        sx: {
          height: { xs: 'calc(100vh - 16px)', md: '80vh' },
          maxHeight: { xs: 'calc(100vh - 16px)', md: '80vh' },
          maxWidth: 'none',
          width: { xs: 'calc(100vw - 16px)', md: '80vw', xl: '1400px' },
        },
      }}
    >
      <DialogTitle
        id={`vehicle-details-dialog-title-${vehicleId}`}
        sx={{
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          minHeight: 60,
          px: { xs: 2, md: 3 },
          py: 1.25,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography noWrap sx={{ color: '#0F172A', fontSize: { xs: 17, md: 20 }, fontWeight: 800 }}>
            {editing ? 'Edit vehicle' : (vehicleNumber || 'Vehicle details')}
          </Typography>
          <Typography sx={{
            color: '#64748B', fontSize: 12, fontWeight: 700, mt: 0.25
          }}
          >
            {editing ? 'Update vehicle information and features' : 'Complete vehicle overview'}
          </Typography>
        </Box>
        <IconButton aria-label="Close vehicle details" onClick={closeDialog} size="small">
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          minHeight: 0,
          overflowY: 'auto',
          p: 0,
        }}
      >
        {editing ? (
          <VehicleEditPage
            vehicleId={vehicleId}
            embedded
            initialSection={editSection}
            onCancel={() => setEditing(false)}
            onSaved={() => setEditing(false)}
          />
        ) : (
          <VehicleDetailsV2 vehicleId={vehicleId} embedded onClose={closeDialog} onEdit={openEditor} />
        )}
      </DialogContent>
    </Dialog>
  );
};

VehicleDetailsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  vehicleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  vehicleNumber: PropTypes.string,
};

export default VehicleDetailsDialog;
